export default {
    common: {
        add: 'Add',
        no_data: 'No data to display',
        email:    'Email',
        fullName: 'Full name',
        login:    'Login',
        general: 'Information',
        headquarters: 'Headquarters',
        comment: 'Notes',
        attachments: 'Documents',
        citizenship: 'Citizenship',
        male: 'Male',
        female: 'Female',
        sex: 'Sex',
        age: 'Age',
        languages: 'Foreign languages',
        city: 'City',
        language_level: {
            32: 'Middle',
            16: 'Basic',
            8: 'Read prof. literature',
            4: 'Conversational',
            2: 'Fluent'
        },
        any: 'Any',
        lessThanDay: 'Less than a day',
        ago: 'ago',
        showPopover: 'Show all lines',
        refresh: 'Refresh',
        yes: 'Yes',
        no: 'No'
    },
    company: {
        phone: 'Phone',
        address: 'Address',
        tags: 'Tags'
    },
    classifier: 'Classifier',
    modal_settings: {
        save: 'Save',
        cancel: 'Close',
        default: 'Default'
    }
};
